<template>
  <div class="favorites-page">
    <Header @cart-ref="setCartRef" />
    <div id="loading-overlay" v-if="loading">
      <img src="@/assets/gifs/loading.gif" alt="Carregando" class="loading-gif">
    </div>
    <div class="main-content" v-show="!loading">
      <div class="favorites-container">
        <h2 class="title-favorites"><i class="fa-solid fa-heart"></i> Meus Favoritos</h2>
        
        <div v-if="favorites.length === 0" class="no-results">
            <i class="fa-regular fa-heart" style="font-size: 48px; margin-bottom: 20px; display: block;"></i>
            Você ainda não adicionou nenhum item aos favoritos.
        </div>

        <div v-else class="grid-favorites">
            <CardDiscipline 
                v-for="discipline in favorites" 
                :key="discipline.codigo_disciplina" 
                :discipline="discipline" 
                @add-to-cart="addToCart" 
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import CardDiscipline from '@/components/CardDiscipline.vue';
import '@/styles/Profile.css'; /* Reusing the profile layout styles */

export default {
  name: 'Favorites',
  components: {
    Header,
    CardDiscipline
  },
  data() {
    return {
      loading: true,
      cartComponent: null,
      favorites: [
        {
          codigo_disciplina: 101,
          nome_disciplina: 'Física Moderna Avançada',
        },
        {
          codigo_disciplina: 102,
          nome_disciplina: 'Introdução à Programação (Python)',
        },
        {
          codigo_disciplina: 103,
          nome_disciplina: 'Marketing Digital e Vendas',
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // Simulating API loading
    setTimeout(() => {
      this.loading = false;
    }, 800);
  },
  methods: {
    setCartRef(cartRef) {
      this.cartComponent = cartRef;
    },
    addToCart(item) {
      if (this.cartComponent) {
        this.cartComponent.addToCart(item);
      }
    }
  }
};
</script>

<style scoped>
.favorites-page {
  background-image: linear-gradient(to bottom, #09105D, #1322C1);
  min-height: 100vh;
  width: 100%;
  padding-bottom: 60px;
  font-family: 'Inter', sans-serif;
}

.main-content {
  padding-top: 20px;
}

.favorites-container {
  margin-top: 100px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.title-favorites {
  color: #FEC401;
  font-size: 28px;
  margin-bottom: 40px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
}

.grid-favorites {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
}

.no-results {
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 40px;
  font-size: 18px;
  padding: 60px 40px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
  border: 1px dashed rgba(255, 255, 255, 0.1);
}

#loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(to bottom, #09105D, #1322C1);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-gif {
  width: 500px;
  height: 300px;
}
</style>
